export function commonFunc() {
	handleSamePageAnchorLinks();
	handleCrossPagesAnchorLinks();
	fadeInUp();
	awardParallax();
	bakeryParallax();
	aboutParallax();
}

/**
 * アンカーリンク（同一ページ内）
 */
function handleSamePageAnchorLinks() {
	const header = document.querySelector('.l-header-menu');
	const headerHeight = window.innerWidth <= 767 && header ? header.offsetHeight : 0;

	function handleAnchorClick(event) {
		const target = event.target.closest('a[href*="#"]');
		if (target) {
			const href = target.getAttribute('href');
			const anchorIndex = href.indexOf('#');

			if (anchorIndex !== -1) {
				const targetUrlWithoutHash = href.slice(0, anchorIndex);
				const currentUrlWithoutHash = window.location.pathname + window.location.search;

				const isSamePageLink = (targetUrlWithoutHash === '' || targetUrlWithoutHash === currentUrlWithoutHash);

				if (isSamePageLink) {
					event.preventDefault();
					const targetId = href.slice(anchorIndex + 1);
					const targetElement = document.getElementById(targetId);
					if (targetElement) {
						const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
						window.scrollTo({
							top: targetPosition - headerHeight,
							behavior: 'smooth'
						});
					}
				}
			}
		}
	}

	document.addEventListener('click', handleAnchorClick);
}

/**
 * アンカーリンク（ページ遷移）
 */
function handleCrossPagesAnchorLinks() {
	const header = document.querySelector('.l-header-menu');
	const headerHeight = window.innerWidth <= 767 && header ? header.offsetHeight : 0;

	if (window.location.hash) {
		const targetId = window.location.hash.slice(1);
		const targetElement = document.getElementById(targetId);
		if (targetElement) {
			const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
			window.scrollTo({
				top: targetPosition - headerHeight,
				behavior: 'smooth'
			});
		}
	}
}

/**
 * フェードイン
 */
function fadeInUp() {
	var fadeElements = document.querySelectorAll('.js-fade-in');

	function checkFade() {
		fadeElements.forEach(function(element) {
			const elementTop = element.getBoundingClientRect().top;
			const triggerPoint = window.innerHeight * 0.8; // 画面に上部10%

			if (elementTop < triggerPoint) {
				element.classList.add('is-visible');
			}
		});
	}

	// 初回チェック
	checkFade();

	// スクロール時にチェック
	window.addEventListener('scroll', checkFade);
}

/**
 * Aboutのパララックス
 */
function aboutParallax() {
	const bg = document.querySelector('.p-home-about__image');
	const image01 = bg.querySelectorAll('.image01');
	const image02 = bg.querySelectorAll('.image02');
	const image03 = bg.querySelectorAll('.image03');

	function updateParallax() {
		const rect = bg.getBoundingClientRect();

		console.log('rect.top', rect.top);
		console.log('rect.bottom', rect.bottom);
		console.log('window.innerHeight', window.innerHeight);

		// 要素が画面内に入っているかチェック
		if (rect.top < window.innerHeight && rect.bottom > 0) {
			const offsetY = Math.max(0, window.innerHeight - rect.top);
			image01.forEach(el => {
				el.style.transform = `translateY(${-offsetY * 0.2}px)`;
			});

			image02.forEach(el => {
				el.style.transform = `translateY(${-offsetY * 0.8}px)`;
			});

			image03.forEach(el => {
				el.style.transform = `translateY(${-offsetY * 1.5}px)`;
			});
		}
	}

	window.addEventListener('scroll', () => {
		window.requestAnimationFrame(updateParallax);
	});
}

/**
 * Bakeryのパララックス
 */
function bakeryParallax() {
	const bg = document.querySelector('.p-home-bakery__image');
	const image01 = bg.querySelectorAll('.image01');
	const image02 = bg.querySelectorAll('.image02');
	const image03 = bg.querySelectorAll('.image03');

	function updateParallax() {
		const rect = bg.getBoundingClientRect();

		console.log('rect.top', rect.top);
		console.log('rect.bottom', rect.bottom);
		console.log('window.innerHeight', window.innerHeight);

		// 要素が画面内に入っているかチェック
		if (rect.top < window.innerHeight && rect.bottom > 0) {
			const offsetY = Math.max(0, window.innerHeight - rect.top);
			image01.forEach(el => {
				el.style.transform = `translateY(${-offsetY * 0.2}px)`;
			});

			image02.forEach(el => {
				el.style.transform = `translateY(${-offsetY * 0.8}px)`;
			});

			image03.forEach(el => {
				el.style.transform = `translateY(${-offsetY * 1.5}px)`;
			});
		}
	}

	window.addEventListener('scroll', () => {
		window.requestAnimationFrame(updateParallax);
	});
}

/**
 * AWARDのパララックス
 */
function awardParallax() {
	const bg = document.querySelector('.p-home-award-bg');
	const nearElements = bg.querySelectorAll('.near');
	const middleElements = bg.querySelectorAll('.middle');
	const farElements = bg.querySelectorAll('.far');

	function updateParallax() {
		const rect = bg.getBoundingClientRect();

		// 要素が画面内に入っているかチェック
		if (rect.top < window.innerHeight && rect.bottom > 0) {
			console.log(rect.top );
			console.log(rect.bottom );
			console.log(window.innerHeight );
			const offsetY = Math.max(0, window.innerHeight - rect.top);
			nearElements.forEach(el => {
				el.style.transform = `translateY(${-offsetY * 1.5}px)`;
			});

			middleElements.forEach(el => {
				el.style.transform = `translateY(${-offsetY * 0.8}px)`;
			});

			farElements.forEach(el => {
				el.style.transform = `translateY(${-offsetY * 0.2}px)`;
			});
		}
	}

	window.addEventListener('scroll', () => {
		window.requestAnimationFrame(updateParallax);
	});
}